import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-unavailable-text',
  templateUrl: './unavailable-text.component.html',
  styleUrls: ['./unavailable-text.component.scss'],
})
export class UnavailableTextComponent implements OnInit {
  @Input() customClass: string = '';
  constructor() { }

  ngOnInit() { }

}
